var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"wfs--button",attrs:{"to":{ name: _vm.nome, params: { opcao: _vm.op  } }}},[_vm._v(" "+_vm._s(_vm.titulo)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }